import { formatInteger } from "@/helpers/utils";

// Formats an integer
export default function (value) {
  return formatInteger(value);
}
